export enum AggregationType {
  SUM = 'SUM',
  COUNT = 'COUNT',
  CALC = 'CALC',
}
